/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import config from '@/config'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/
/**
 * restart the queue
 */
export const restartQueue = async () => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'post',
            url: getEndpoint('/system/restart-queue'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}